<script setup>
import { ref } from 'vue';
import { useTestsStore } from '@stores';
import TestCard from './components/TestCard.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });

const { createTest } = useTestsStore();

const search = ref('');
</script>

<template>
    <div class="test-constructor">
        <div class="test-constructor-top">
            <IconField>
                <InputIcon class="pi pi-search" />
                <InputText v-model="search" :placeholder="t('tests.search')" />
            </IconField>
            <Button icon="pi pi-plus" :label="t('tests.create')" @click="createTest" />
        </div>
        <TestCard />
    </div>
</template>

<style scoped>
.test-constructor {
    @apply flex flex-col gap-4;
}
.test-constructor-top {
    @apply p-4 bg-white flex items-center justify-between;
}
</style>
